<nwm-menu />
<div class="content" [ngClass]="{'loading': loading || loadingClients || loadingFiles}">
  @if (isCollapse) {
    <button aria-label="Expand Sidebar" class="expand-btn d-print-none" (click)="isCollapse = false"><i class="fa fa-angle-right"></i></button>
  }
  <div class="main">
    <div class="row" [ngClass]="{'ml-3': isCollapse}">
      <div class="col-xxl-10 offset-xxl-1">
        <div class="row">
          <div class="clientMenu side-menu d-print-none" [ngClass]="{'col-lg-3': !isCollapse ,'d-none': isCollapse}">
            <button aria-label="Collapse Sidebar" class="collapse-btn" (click)="isCollapse = true"><i class="fa fa-angle-left"></i></button>
            <div class="clientMenu-content pt-lg-4">
              <side-menu
                #clientSideMenu
                class="full-height no-indent dont-indent-sticky-header"
                menuTitle="Choose Client"
                [defaultTitle]="'Choose Client'"
                [items]="clientMenuItems"
                [active]="selectedClient?.clientId"
                (menuChange)="changeClient($event)">
                <div class="h3-text d-none d-lg-block">Choose Client</div>
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="flexSwitchCheckDefault" [(ngModel)]="newDocumentsOnly" (change)="filterFiles()">
                  <label class="custom-control-label" for="flexSwitchCheckDefault">New Documents Only</label>
                </div>
                <hr>
              </side-menu>
            </div>
          </div>

          <div class="w-print-100 mb-5 mt-4" [ngClass]="{'col-lg-9 offset-lg-3': !isCollapse,'col-lg-12': isCollapse}" >

            <div class="row my-4">
              <div class="col-sm-8"><h1>Documents {{this.selectedClient && '- ' + this.selectedClient.clientName}}</h1></div>
              <div class="col-sm-4 text-right">
                <button class="btn-secondary sml-btn mr-3" (click)="modalService.open(contactUsModal, { size: 'lg' })">Contact Us</button>
<!--                in the new workflow, if the accountant wants to upload a document, they need to do it via an email or contact us; The advisory team will need to upload in the corresponding drawer-->
<!--                <button class="btn-primary sml-btn" (click)="modalService.open(uploadDocumentModal, { size: 'lg' })">Upload Documents</button>-->
              </div>
            </div>
            <div class="row">

              <div class="col-lg-7 mt-3 mt-lg-0 filters-bar">
                <div class="dates mt-lg-3">
                  <div class="input-group">
                    <label class="date-label mr-2 mb-3" for="startDateField"><b>From</b></label>
                    <div class="date-selector mb-3">
                      <input class="form-control" [placeholder]="displayStartDate" name="startDateField" [(ngModel)]="startDateModel" ngbDatepicker #startDateField="ngbDatepicker" (ngModelChange)="dateChange()"
                        id="startDateField" placement="bottom-left" [footerTemplate]="startDateFooter" [minDate]='minDate' [maxDate]='maxDate' datepicker-options="{startingDay:0}">
                      <button class="button-without-border fa fa-calendar" aria-label="Open Date Selector" (click)="startDateField.toggle()"></button>
                    </div>
                    <label class="date-label mx-3 mb-3" for="endDateField"><b>To</b></label>
                    <div class="date-selector mb-3">
                      <input id="endDateField" class="form-control" [placeholder]="displayEndDate" name="endDateField" [(ngModel)]="endDateModel" ngbDatepicker #endDateField="ngbDatepicker" (ngModelChange)="dateChange()"
                        placement="bottom-right" [footerTemplate]="endDateFooter" [minDate]='minDate' [maxDate]='maxDate'>
                      <button class="button-without-border fa fa-calendar" aria-label="Open Date Selector" (click)="endDateField.toggle()"></button>
                    </div>
                    <button class="btn-secondary ml-3 mb-3" [disabled]="disableResetDateButton" (click)="resetDateRange()" style="height:38px;line-height:38px">
                      <span>Reset Range</span>
                      <i class="fa fa-repeat ml-2"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-lg-5 mt-3 mt-lg-0 mb-2 filters-bar">
                <input type="text" name="keyword" id="keyword" value="" placeholder="Filter by Keyword" [(ngModel)]="filterText" (keyup.enter)="filterFiles()" class="form-control my-lg-3">
                <i aria-label="Search" role="button" tabindex="0" class="search-icon fa my-lg-3 fa-search" (click)="filterFiles()"></i>
              </div>

              <div class="mt-4 col-12">
                <div class="scrollable-wrap">
                  <div class="scrollable">
                    <div class="scrollable-button left"></div>
                    <div class="scrollable-button"></div>
                    <table width="100%" class="NWMtable sticky_header docTable table table-striped mb-0">
                      <thead>
                        <tr>
                          <td width="40">
                            <input aria-label="Select/Unselect all" type="checkbox" [checked]="areAllPagedFilesSelected()" (change)="toggleSelectAll()">
                          </td>
                          <td (click)="sort('fileName')" class="sortable">
                            <span>File Name</span>
                            <i class="fa ml-2" [ngClass]="sortColumn === 'fileName' ? (sortDirection === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="140" role="button" class="text-left sortable" (click)="sort('updatedAt')" style="white-space:nowrap">
                            <span>Date Posted</span>
                            <i class="fa ml-2" [ngClass]="sortColumn === 'updatedAt' ? (sortDirection === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="160" role="button" class="d-none d-sm-table-cell text-left sortable" (click)="sort('downloadedAt')" style="white-space:nowrap">
                            <span>Date Downloaded</span>
                            <i class="fa ml-2" [ngClass]="sortColumn === 'downloadedAt' ? (sortDirection === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                          </td>
                          <td width="122" class="d-none d-sm-table-cell text-right"></td>
                        </tr>
                      </thead>
                      <tbody>
                        @for (file of filteredFileListPaged; track file.downloadToken) {
                          <tr (click)="viewFile(file)">
                            <td class="checkbox-cell align-middle" (click)="$event.stopPropagation()">
                              <input aria-label="Select/Unselect" type="checkbox" [checked]="isFileSelected(file)" (change)="toggleFileSelection(file)">
                            </td>
                            <td class="text-left align-middle" style="white-space:nowrap">
                              <span class="d-inline-block text-truncate align-middle" [title]="file.fileName">{{file.fileName}}</span>
                              @if (isNewFile(file)) {
                                <div class="new"></div>
                              }
                            </td>
                            <td class="text-left align-middle">
                              {{file.updatedAt | date:'MMM d, yyyy' | uppercase}}
                            </td>
                            <td class="d-none d-sm-table-cell text-left align-middle">
                              {{file.downloadedAt | date:'MMM d, yyyy' | uppercase}}
                            </td>
                            <td class="d-none d-sm-table-cell pr-1 action-links text-right">
                              <a class="px-3 py-2" (click)="downloadFile(file, $event)" tabindex="-1">Download</a>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="float-left form-inline pt-4">
                  <div class="form-group mr-2">
                    <button title="Use the checkboxes above to select multiple files to download" [disabled]="selectedFiles.size === 0" class="btn-secondary" (click)="downloadSelectedFiles()">Download Selected ({{ selectedFiles.size }})</button>
                  </div>
                </div>

                <div class="form-inline float-right mb-4">
                  <app-pagination
                    [filteredList]="filteredFileList"
                    [pageOptions]="[10, 20, 50, 100]"
                    [initialPageSize]="20"
                    (pageChange)="filteredFileListPaged = $event"
                  ></app-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #startDateFooter>
  <hr class="my-0">
  <div class="mx-auto text-center">
    <button class="btn btn-NWM btn-sm m-2" (click)="setStartDateToToday(startDateField)">Today</button>
  </div>
</ng-template>

<ng-template #endDateFooter>
  <hr class="my-0">
  <div class="mx-auto text-center">
    <button class="btn btn-NWM btn-sm m-2" (click)="setEndDateToToday(endDateField)">Today</button>
  </div>
</ng-template>

<ng-template #contactUsModal let-modal>
  <nwm-advisor-contact formAction="MessageAdvisor" formTitle="Contact Us" (formCancelled)="modal.close()"></nwm-advisor-contact>
</ng-template>
<ng-template #uploadDocumentModal let-modal>
  <nwm-advisor-contact formAction="SendDocuments" formTitle="Upload Documents" (formCancelled)="modal.close()"></nwm-advisor-contact>
</ng-template>
